import { issueFinished } from "./successNotification.js";


/**
 * @param heftausgabe_id
 * @param anzahl_ungelesen
 */
export function updateIssueTeaser(heftausgabe_id, anzahl_ungelesen) {
    const teaser = document.getElementById("heftausgabe_teaser_" + heftausgabe_id);
    const element_anzahl = teaser.querySelector("#ungelesene_heftausgabe_teaser_" + heftausgabe_id + " > span");
    // Zahl durch aktuelle Zahl ungelesener Artikel
    if (anzahl_ungelesen !== 0 && element_anzahl) {
        element_anzahl.textContent = anzahl_ungelesen;
    }

    if (anzahl_ungelesen === 0) {
        if (element_anzahl) {
            element_anzahl.textContent = "";
            element_anzahl.classList.remove("bg-neutral-10");
            element_anzahl.classList.remove("text-[9px]");
            element_anzahl.classList.remove("text-skin-dark");
            element_anzahl.classList.remove("font-medium");
            element_anzahl.classList.add("bg-skin-brand");
            element_anzahl.classList.add("text-skin-onColor");
            element_anzahl.classList.add("text-base");
            element_anzahl.classList.add("before:font-icomoon");
            element_anzahl.classList.add("before:content-checkmark");
        }

        const teaser_image = teaser.querySelector("img");
        if (teaser_image) {
            teaser_image.classList.add("opacity-50");
        }

        const element_informationsdienst = teaser.querySelector("#informationsdienst_heftausgabe_teaser_" + heftausgabe_id);
        // Informationsdiensttitel in "als gelesen"-Status umwandeln
        if (element_informationsdienst) {
            element_informationsdienst.classList.remove("bg-skin-brand");
            element_informationsdienst.classList.remove("text-skin-onColor");
            element_informationsdienst.classList.add("bg-skin-brandBackground");
            element_informationsdienst.classList.add("text-skin-brand/60");
        }

        const element_ausgabe = teaser.querySelector("#ausgabennummer_heftausgabe_teaser_" + heftausgabe_id);
        // Zahl durch Checkbox austauschen
        if (element_ausgabe) {
            element_ausgabe.classList.remove("text-skin-dark");
            element_ausgabe.classList.add("text-skin-dark/60");
        }

        const element_jahr = teaser.querySelector("#jahr_heftausgabe_teaser_" + heftausgabe_id);
        // Zahl durch Checkbox austauschen
        if (element_jahr) {
            element_jahr.classList.remove("text-skin-dark/60");
            element_jahr.classList.add("text-skin-dark/30");
        }
    }
}


/**
 * @param heftausgabe_id
 * @param ungelesene_artikel
 */
export function updateIssueFilter(heftausgabe_id, ungelesene_artikel) {
    const element_anzahl_ungelesene = document.getElementById("ausgabe_ungelesene_" + heftausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = "";
        element_anzahl_ungelesene.classList.add("before:content-checkmark");
        element_anzahl_ungelesene.classList.add("before:font-icomoon");
        element_anzahl_ungelesene.classList.add("before:text-xl");
        element_anzahl_ungelesene.classList.add("before:text-skin-medium");
        element_anzahl_ungelesene.classList.add("before:leading-none");
        element_anzahl_ungelesene.classList.add("before:relative");
        element_anzahl_ungelesene.classList.add("before:-top-[2px]");
    } else if (element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene.classList.remove("before:content-checkmark");
        element_anzahl_ungelesene.classList.remove("before:font-icomoon");
        element_anzahl_ungelesene.classList.remove("before:text-xl");
        element_anzahl_ungelesene.classList.remove("before:text-skin-medium");
        element_anzahl_ungelesene.classList.remove("before:leading-none");
        element_anzahl_ungelesene.classList.remove("before:relative");
        element_anzahl_ungelesene.classList.remove("before:-top-[2px]");

    }

    // Gleiches nochmal, falls es sich um aktuell ausgewaehltes Jahr handelt - braucht andere Klassen
    const element_anzahl_ungelesene_ausgewaehlt = document.getElementById("ausgabe_ungelesene_ausgewaehlt_" + heftausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = "";
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:content-checkmark");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:font-icomoon");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:text-xl");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:text-skin-medium");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:leading-none");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:relative");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:top-[2px]");

        issueFinished();
    } else if (element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:content-checkmark");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:font-icomoon");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:text-xl");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:text-skin-medium");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:leading-none");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:relative");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:top-[2px]");
    }
}


/**
 * @param filter_element
 * @param anzahl_ungelesene
 */
export function updateYearFilter(filter_element, anzahl_ungelesene) {
    // Zahl durch Checkbox austauschen
    if (anzahl_ungelesene === 0) {
        filter_element.textContent = "";
        filter_element.classList.remove("rounded-r");
        filter_element.classList.remove("border");
        filter_element.classList.remove("border-l-0");
        filter_element.classList.remove("border-skin-light");
        filter_element.classList.remove("px-2.5");
        filter_element.classList.remove("pt-1");
        filter_element.classList.remove("pb-0");
        filter_element.classList.remove("text-skin-medium");
        filter_element.classList.add("relative");
        filter_element.classList.add("-top-[2px]");
        filter_element.classList.add("leading-none");
        filter_element.classList.add("pl-2");
        filter_element.classList.add("before:content-checkmark");
        filter_element.classList.add("before:font-icomoon");
        filter_element.classList.add("before:text-xl");
        filter_element.classList.add("before:text-skin-medium");
        filter_element.classList.add("group-hover:before:text-skin-dark");
        filter_element.classList.add("before:leading-none");
    } else {
        filter_element.textContent = anzahl_ungelesene;
    }
}


/**
 * @param filter_element
 * @param anzahl_ungelesene
 */
export function updateSelectedYearFilter(filter_element, anzahl_ungelesene) {
    if (anzahl_ungelesene === 0) {
        filter_element.textContent = "";
        filter_element.classList.remove("text-skin-medium");
        filter_element.classList.add("before:content-checkmark");
        filter_element.classList.add("before:font-icomoon");
        filter_element.classList.add("before:text-xl");
        filter_element.classList.add("before:text-skin-medium");
        filter_element.classList.add("group-hover:before:text-skin-dark");
        filter_element.classList.add("before:leading-none");
        filter_element.classList.add("before:relative");
        filter_element.classList.add("before:top-[2px]");
    } else {
        filter_element.textContent = anzahl_ungelesene;
    }
}


/**
 * @param ausgabe_id
 * @param ungelesene_artikel
 */
export function updateNewsletterIssueFilter(ausgabe_id, ungelesene_artikel) {
    const element_anzahl_ungelesene = document.getElementById("newsletterausgabe-ungelesene-" + ausgabe_id);

    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = "";
        element_anzahl_ungelesene.classList.add("before:content-checkmark");
        element_anzahl_ungelesene.classList.add("before:font-icomoon");
        element_anzahl_ungelesene.classList.add("before:text-xl");
        element_anzahl_ungelesene.classList.add("before:text-skin-medium");
        element_anzahl_ungelesene.classList.add("before:leading-none");
        element_anzahl_ungelesene.classList.add("before:relative");
        element_anzahl_ungelesene.classList.add("before:-top-[2px]");
    } else if (element_anzahl_ungelesene) {
        element_anzahl_ungelesene.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene.classList.remove("before:content-checkmark");
        element_anzahl_ungelesene.classList.remove("before:font-icomoon");
        element_anzahl_ungelesene.classList.remove("before:text-xl");
        element_anzahl_ungelesene.classList.remove("before:text-skin-medium");
        element_anzahl_ungelesene.classList.remove("before:leading-none");
        element_anzahl_ungelesene.classList.remove("before:relative");
        element_anzahl_ungelesene.classList.remove("before:-top-[2px]");
    }

    // Gleiches nochmal, falls es sich um aktuell ausgewaehltes Jahr handelt - braucht andere Klassen
    const element_anzahl_ungelesene_ausgewaehlt = document.getElementById("newsletterausgabe-ungelesene-ausgewaehlt-" + ausgabe_id);
    // Zahl durch Checkbox austauschen
    if (ungelesene_artikel === 0 && element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = "";
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:content-checkmark");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:font-icomoon");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:text-xl");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:text-skin-medium");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:leading-none");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:relative");
        element_anzahl_ungelesene_ausgewaehlt.classList.add("before:top-[2px]");

        issueFinished();
    } else if (element_anzahl_ungelesene_ausgewaehlt) {
        element_anzahl_ungelesene_ausgewaehlt.textContent = ungelesene_artikel;
        // Es wurde gerade ein Artikel als ungelesen markiert
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:content-checkmark");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:font-icomoon");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:text-xl");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:text-skin-medium");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:leading-none");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:relative");
        element_anzahl_ungelesene_ausgewaehlt.classList.remove("before:top-[2px]");
    }
}


/**
 * @param newsletter_id
 * @param anzahl_ungelesen
 */
export function updateNewsletterIssueTeaser(newsletter_id, anzahl_ungelesen) {
    const teaser = document.getElementById("newsletterausgabe_teaser_" + newsletter_id);
    const element_anzahl = teaser.querySelector("span[class=\"relative top-[1px]\"]");

    if (anzahl_ungelesen !== 0 && element_anzahl) {
        element_anzahl.textContent = anzahl_ungelesen;
    }

    if (anzahl_ungelesen === 0) {
        if (element_anzahl) {
            element_anzahl.textContent = "";
            element_anzahl.className = "before:font-icomoon before:content-checkmark text-skin-onColor rounded-full bg-skin-brand text-base w-[16px] h-[16px] flex justify-center items-center";
        }

        const element_upper_background = teaser.querySelector("div[class=\"flex justify-between items-start p-2.5 bg-skin-brand border-b border-transparent\"]");
        if (element_upper_background) {
            element_upper_background.className = "flex justify-between items-start p-2.5 bg-white border-b border-neutral-10";
        }

        const element_icon = teaser.querySelector("span[class=\"before:font-icomoon before:content-at before:text-white/20 before:leading-none mr-1 h-0\"]");
        if (element_icon) {
            element_icon.className = "before:font-icomoon before:content-at before:text-skin-brand/20 before:leading-none mr-1 h-0";
        }

        const element_informationsdienst = teaser.querySelector("span[class=\"bg-white rounded p-1 pb-0 text-xs text-skin-brandText font-medium leading-none\"]");
        // Zahl durch Checkbox austauschen
        if (element_informationsdienst) {
            element_informationsdienst.className = "bg-skin-brand/10 rounded p-1 pb-0 text-xs text-skin-brandText/50 font-medium leading-none";
        }

        const element_ausgabe = teaser.querySelector("span[class=\"inline-block text-4xl font-medium text-skin-dark tracking-tighter\"]");
        // Zahl durch Checkbox austauschen
        if (element_ausgabe) {
            element_ausgabe.classList.remove("text-skin-dark");
            element_ausgabe.classList.add("text-skin-dark/60");
        }

        const element_jahr = teaser.querySelector("span[class=\"text-sm font-medium leading-4 block text-skin-dark/60 relative top-[1px]\"]");
        // Zahl durch Checkbox austauschen
        if (element_jahr) {
            element_jahr.classList.remove("text-skin-dark/60");
            element_jahr.classList.add("text-skin-dark/30");
        }
    }
}
